import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import BookButton from "@/components/ui/BookButton";
import Subtitle from "@/components/ui/subtitle";
import Image from "next/image";
import aiChatbotImage from "@/public/images/ai-chat.png";
import clsx from "clsx";

const AiChat = () => {
  const content = {
    title: "AI Customer Service Agent",
    subtitle: "New Service",
    description:
      "The Ventura AI Customer Service Agent is a 24/7 automated customer service tool. Add this feature to your website to increase conversions by automatically answering customer questions about your business, services, and products.",
    list: [
      {
        title: "Increase Conversion Rate",
        description: "Boost sales by engaging visitors instantly with automated answers.",
        icon: <FaCheckCircle className="text-vblue3" />,
      },
      {
        title: "Save Time and Cut Costs",
        description: "Reduce support overhead and free your team to focus on growth.",
        icon: <FaCheckCircle className="text-vblue3" />,
      },
      {
        title: "Advanced AI Trained Support",
        description: "Deliver smarter responses powered by continuous machine-learning.",
        icon: <FaCheckCircle className="text-vblue3" />,
      },
      {
        title: "Customized to Your Website",
        description: "Seamlessly match your brand and integrate with any page layout.",
        icon: <FaCheckCircle className="text-vblue3" />,
      },
    ],
  };

  return (
    <section id="ai-chatbot" className="relative bg-white py-[50px]">
      <div className="relative mx-auto max-w-screen-xl px-5">
        <div className="flex w-full flex-col-reverse items-center justify-between gap-10 lg:flex-row lg:gap-20">
          <div className="lg:w-2/3">
            <Subtitle
              subtitle={content.subtitle}
              textColor="text-vblue3"
              gradientTextColor="from-vblue2 to-vcyan1"
            />
            <h2 className="mb-2.5 text-3xl font-bold tracking-tight lg:text-4xl">
              {content.title}
            </h2>
            <p className="text-lg">{content.description}</p>
            <ul className="my-5 mr-auto grid justify-start gap-2.5 lg:grid-cols-2">
              {content.list.map((item) => {
                return (
                  <li
                    key={item.description}
                    className={clsx(
                      "flex items-center gap-2.5 font-montserrat font-semibold",
                      item.span && "lg:col-span-2",
                    )}
                  >
                    {item.icon}
                    {item.title}
                  </li>
                );
              })}
            </ul>
            <div className="mt-6 flex">
              <BookButton
                color="blue"
                text="Learn More About Our AI Chat Agent"
                custom="!w-full px-5"
                link="/addons/ai-customer-service-agent"
                right
                icon={<FaArrowRight />}
              />
            </div>
          </div>
          <div className="w-full max-w-md lg:block lg:w-3/5 lg:max-w-none">
            <Image
              loading="lazy"
              src={aiChatbotImage}
              alt="Ecommerce Website Design"
              sizes="(min-width: 1380px) 549px, (min-width: 1100px) calc(32.69vw + 104px), (min-width: 520px) 442px, calc(94vw - 22px)"
              quality={75}
              className="mx-auto h-auto rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiChat;
